import {Component, inject, REQUEST, RESPONSE_INIT} from '@angular/core';

@Component({
  selector: 'app-not-found-page',
  imports: [],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.scss'
})
export class NotFoundPageComponent {
  response = inject(RESPONSE_INIT, {optional: true});
  request = inject(REQUEST, {optional: true});

  constructor() {
    if (this.response) {
      this.response.status = 404;
    }
  }
}
